import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import SearchLayout from '../Layouts/Search'
import DataTable from '../DataTable'
import Button from '../../UniformComponents/Button'
import Anchor from '../../UniformComponents/Anchor'
import Tooltip from '../../UniformComponents/Tooltip'
import DivisionEdit from './DivisionEdit'
import DivisionStore from './DivisionStore'
import Badge from '../../UniformComponents/Badge'
import { PageSwitchTab, tabOptions } from '../PageSwitchTab'
import { removeQueryParam, setQueryParam, getQueryParam } from '../../utils/helpers'

const DIVISION_PARAM = 'divisionId'

@observer
class DivisionSearch extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            divisionId: 0,
        }
        this.divisionStore = new DivisionStore(props.store)
        this.setColumns()
    }

    componentDidMount() {
        const { store, location } = this.props

        store.breadcrumps = [
            {
                name: 'division',
                url: '/division',
                title: 'Manage Divisions',
            },
        ]
        this.divisionStore.initSearch()

        this.checkQueryParam(location)
    }

    checkQueryParam = (location) => {
        const divisionId = getQueryParam(location, DIVISION_PARAM)
        if (divisionId === -1) return
        this.handleOpenModal(divisionId)
    }

    setColumns = () => {
        const { store } = this.props
        this.columns = [
            {
                name: i18n.t('division'),
                key: 'name',
                cellClass: 'bold',
            },
            {
                name: i18n.t('num_portfolios'),
                key: 'numPortfolio',
                dataTransform: (completed) => (
                    <Badge
                        type="grey"
                        cssClass="rounded"
                        label={completed}
                    />
                ),
            },
        ]

        if (
            store.tokenData.roles.includes(100)
            || store.tokenData.roles.includes(110)
        ) {
            this.columns.push({
                name: '',
                key: 'divisionId',
                columnClick: this.editDivision,
                cellClass: 'center overflow',
                dataTransform: (divisionId) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => { this.handleOpenModal(divisionId) }}
                        >
                            <Tooltip
                                text={i18n.t('edit_division')}
                                direction="left"
                            />
                            <i className="fa-light fa-edit" />
                        </Anchor>
                    </div>
                ),
            })
        }
    }

    toggleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }))
    }

    handleOpenModal = async (divisionId) => {
        await this.divisionStore.initDivision(divisionId, this.handleCloseModal)
        const { location, history } = this.props
        setQueryParam(location, history, DIVISION_PARAM, divisionId)
        this.setState({ divisionId })
        this.toggleModal()
    }

    handleCloseModal = () => {
        const { location, history } = this.props
        removeQueryParam(location, history, DIVISION_PARAM)
        this.toggleModal()
        this.divisionStore.resetFormState()
    }

    renderFilterOptions = () => {
        const { store } = this.props
        return (
            (
                store.tokenData.roles.includes(100)
                || store.tokenData.roles.includes(110)
            ) && (
                <fieldset className="btn-filter">
                    <Button
                        cssClass="primary large w-100"
                        onClick={() => { this.handleOpenModal(0) }}
                        icon="fa-light fa-circle-plus"
                        label={i18n.t('add_division')}
                    />
                </fieldset>
            )
        )
    }

    renderTablePanel = () => (
        <DataTable
            store={this.divisionStore}
            inMemory
            dataSet={this.divisionStore.filteredList || []}
            columns={this.columns}
            sorting
            sortKey="name"
            sortDesc={1}
            cssClass="search-table"
        />
    )

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('divisionSearch.introText'),
        }}
        />
    )

    render() {
        const { store, location, history } = this.props
        const { showModal, divisionId } = this.state
        return (
            <Fragment>
                <PageSwitchTab
                    userRole={store.userData.role}
                    hasMultiDivision
                    location={location}
                    history={history}
                    tabOptions={tabOptions.manageEvents}
                />
                <SearchLayout
                    pageTitle="Division"
                    renderFilterOptions={this.renderFilterOptions}
                    renderTablePanel={this.renderTablePanel}
                    renderGuide={this.renderGuide}
                    searchStore={this.divisionStore}
                    hideFilterAccordion
                    showGuideAtInit
                    hasTopNav
                />
                <DivisionEdit
                    showModal={showModal}
                    handleCloseModal={this.handleCloseModal}
                    store={store}
                    divisionStore={this.divisionStore}
                    divisionId={divisionId}
                />
            </Fragment>
        )
    }
}

export default DivisionSearch
